import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

// Components
import Loader from '../Loader/Loader';

import style from './Button.module.css';

const Button = ({
  name, children, label, onClick, disabled, isSubmit, className, shape, size, color, icon, isLoading,
}) => (
  <button
    className={cn([className, style.btn, style[shape], style[size], style[color], isLoading ? style.isLoading : null])}
    name={name}
    type={isSubmit ? 'submit' : 'button'}
    onClick={onClick}
    disabled={disabled}
  >
    {isLoading ? <Loader className={style.loader} /> : null}
    {(icon && !isLoading) ? <i className={icon} /> : null}
    {children || label}
  </button>
);

Button.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSubmit: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  shape: PropTypes.oneOf(['border', 'plain']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'secondary', 'accent', 'error', 'warning', 'success']),
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  isSubmit: false,
  disabled: false,
  label: null,
  children: null,
  className: null,
  shape: 'plain',
  size: 'medium',
  color: 'primary',
  icon: null,
  isLoading: false,
};

export default Button;
